import $ from 'jquery'
import { gsap } from 'gsap'

// ._animの付与処理をgsapタイムラインへ追加するための汎用関数
const addAnimToTimeLine = (timeline, selector, timing) => {
  timeline.call(
    () => {
      $(selector).addClass('_anim')
    },
    [],
    timing
  )
}

// 要素の文字列をspanで分割し、クラス、スタイルを設定する関数
const textSplitBySpan = ($el, className, style) => {
  const text = $el.text()
  $el.empty()
  text.split('').forEach(function (t) {
    $el.append(`<span class="${className}" style="${style}">${t}</span>`)
  })
}

function init() {}
function ready() {
  // .js-main-lead-body > span内の文字列をアニメーション用に分割&クラス付与
  const fvLeadTextInit = () => {
    const animClass = $('.js-main-lead-body').attr('data-anim-class')
    const $lines = $('.js-main-lead-body > span')
    $lines.each((i, el) => {
      textSplitBySpan(
        $(el),
        // 'js-main-lead-text c-anim-fadeInUpSoftest',
        `js-main-lead-text ${animClass}`,
        'display:inline-block;'
      )
    })
    $('.js-main-lead-body').css('opacity', '1')
  }

  const leadTextAnimation = () => {
    $('.js-main-lead-text').each((i, el) => {
      setTimeout(() => {
        $(el).addClass('_anim')
      }, (i + 1) * 30)
    })
  }

  // ファーストビューのアニメーション（タイムラインで管理）
  const firstViewAnimation = () => {
    if (!$('.js-header')[0]) return
    const fvTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.js-header',
        start: 'top center',
      },
    })

    addAnimToTimeLine(fvTl, '.js-h1-en', 0.2)
    addAnimToTimeLine(fvTl, '.js-h1-ja', '>0.3')
    addAnimToTimeLine(fvTl, '.js-main-img-container', '>0.4')
    addAnimToTimeLine(fvTl, '.js-main-img', '<')
    addAnimToTimeLine(fvTl, '.js-main-lead-heading', '>0.7')
    fvTl.call(
      () => {
        leadTextAnimation()
      },
      [],
      '>0.7'
    )
  }

  // 各セクションのアニメーション（全て同じ動きのためループ処理）
  const sectionAnimation = () => {
    $('.js-section').each((sectionIndex, el) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: '10% center',
        },
      })

      // 奇数番目のセクションは末尾画像から順にアニメーション（方向が逆になるため）
      const $images =
        sectionIndex % 2 === 0
          ? $(el).find('.js-section-image')
          : $($(el).find('.js-section-image').get().reverse())

      $images.each((index, el) => {
        const timing = index === 0 ? 0 : '>0.3'
        addAnimToTimeLine(tl, el, timing)
      })

      $(el)
        .find('.js-section-content')
        .each((index, el) => {
          const timing = index === 0 ? '>0.4' : '>0.1'
          addAnimToTimeLine(tl, el, timing)
        })
    })
  }

  fvLeadTextInit()
  firstViewAnimation()
  sectionAnimation()
}

export default {
  init() {
    init()
    $(function () {
      ready()
    })
  },
}
